import { FC, useState } from 'react'
import { DateTime } from 'luxon'
import { ProfileDataView } from './ProfileDataView'
import { AllUpdatesView } from './AllUpdatesView'

interface Props {
  employeeId: number
}

// Switches between the worker's profile data on a date
// and every Workday Employee Update received for them
export const WorkdayProfileDataModalContent: FC<Props> = ({ employeeId }) => {
  const [view, setView] = useState<'profileData' | 'allUpdates'>('profileData')
  // Kept here so the chosen date survives a trip to All Updates and back
  const [date, setDate] = useState(() => DateTime.now().startOf('day'))

  if (view === 'allUpdates')
    return (
      <AllUpdatesView
        employeeId={employeeId}
        onBack={() => setView('profileData')}
      />
    )

  return (
    <ProfileDataView
      employeeId={employeeId}
      date={date}
      onDateChange={setDate}
      onViewAllUpdates={() => setView('allUpdates')}
    />
  )
}
